import pdfIcon from "./../../../assets/images/pdf.png"; // Adjust the path as necessary
import { FaFilePdf } from "react-icons/fa";
import Doc1 from "../../../Documents/marine-related/ListofvalidMarineNotices.pdf";
import Doc2 from "../../../Documents/marine-related/List of valid Marine Information Notices.pdf";
import Doc3 from "../../../Documents/marine-related/List of valid Marine Alerts.pdf";
import Doc4 from "../../../Documents/marine-related/List of valid Marine Safety Flashes.pdf";
import { useFileContext } from './../../../Contexts/FileContext';
import React, { useEffect } from 'react';
import CryptoJS from "crypto-js";

function LegislationMarineRelatedInfomation() {
 const {
        setComponentName,
        documents,
        loading,
        setSection
    } = useFileContext();

    useEffect(() => {
        setComponentName("ALL FORMS");
        setSection("");
    }, [setComponentName]);
    const tableStyle = {
        width: "100%",
        borderCollapse: "collapse",
        fontFamily: "Arial, sans-serif",
    };

    const thStyle = {
        backgroundColor: "#008B8B", // Teal header
        color: "white",
        padding: "10px",
        textAlign: "left",
        fontWeight: "bold",
        border: "1px solid #ccc",
    };

    const tdStyle = {
        padding: "10px",
        border: "1px solid #ccc",
    };

    const rowEven = { backgroundColor: "#F9F9F9" };

    const groupedDocs = documents.reduce((acc, doc) => {
        const folder = doc.folderName || 'Uncategorized';
        if (!acc[folder]) acc[folder] = [];
        acc[folder].push(doc);
        return acc;
    }, {});

  return (
    <>
      <div className="service-title font-700 mb-3">LEGISLATION <span className="text-orange-ef3e33 font-400">MARINE RELATED INFOMATION</span></div>


      <h2 className="font-17 font-700 mb-1">Marine Notices (MN):</h2>
      <p className="mb-3 text-primary-color font-17">Marine Notices will explain, and detail technical/statutory requirements linked to legislation. Marine Notices shall be issued with a suffix as follows: </p>

      <div className="row g-3 g-sm-4">
        <div className="col-12">
          <div className="accordion blackTab" id="blackTab">
            <div className="accordion-item">
              <h2 className="accordion-header">
                <button
                  className="accordion-button"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#blackTabOne"
                  aria-expanded="true"
                  aria-controls="blackTabOne"
                >
                  <div className="row g-3">
                    <div className="col-auto">Suffix</div>
                    <div className="col-auto">Marine Notice Type</div>
                  </div>
                </button>
              </h2>
              <div
                id="blackTabOne"
                className="accordion-collapse collapse show"
                data-bs-parent="#blackTab"
              >
                <div className="accordion-body pb-0">

                  


                  <div className="row g-1">

                    <table style={tableStyle}>
                                                    <thead>
                                                        <tr>
                                                            <th style={thStyle}>Suffix</th>
                                                            
                                                            <th style={thStyle}>Marine Notice Type</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr>
                                                            <td style={tdStyle}>C</td>
                                                            <td style={tdStyle}>For Marine Notices relating to Convention vessels</td>
                                                        </tr>
                                                        <tr style={rowEven}>
                                                            <td style={tdStyle}>F</td>
                                                            <td style={tdStyle}>For Marine Notices relating to the Fishing vessels</td>
                                                        </tr>
                                                        <tr>
                                                            <td style={tdStyle}>S</td> 
                                                            <td style={tdStyle}>For Marine Notices relating to Small vessels under the Merchant Shipping (National Small Vessel Safety) Regulations 2007</td>
                                                        </tr>
                                                        <tr style={rowEven}>
                                                            <td style={tdStyle}>P</td>
                                                            <td style={tdStyle}>For Marine Notices relating to Port Operation vessels
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>

                    {/* <div className="col-12">
                      <div className="row g-3">
                        <div className="col-auto pe-2 pe-sm-3 pe-md-5">C</div>
                        <div className="col">For Marine Notices relating to Convention vessels</div>
                      </div>
                    </div>
                    <div className="col-12">
                      <div className="row g-3">
                        <div className="col-auto pe-2 pe-sm-3 pe-md-5">F</div>
                        <div className="col">For Marine Notices relating to the Fishing vessels</div>
                      </div>
                    </div>
                    <div className="col-12">
                      <div className="row g-3">
                        <div className="col-auto pe-2 pe-sm-3 pe-md-5">S</div>
                        <div className="col">For Marine Notices relating to Small vessels under the Merchant Shipping (National Small Vessel Safety) Regulations 2007</div>
                      </div>
                    </div>
                    <div className="col-12">
                      <div className="row g-3">
                        <div className="col-auto pe-2 pe-sm-3 pe-md-5">P</div>
                        <div className="col">For Marine Notices relating to Port Operation vessels</div>
                      </div>
                    </div> */}

                  </div>


                </div>
              </div>
            </div>


          </div>
        </div>

        <div className="col-12">
          <p className="mb-3 text-primary-color font-17">A  combination of suffixes may be used when a Marine Notice applies to two  or more types of vessels, e.g., MN 01-21 (C+F) or MN 02-21 (F+S+P) or  MN 03-21 (C+F+S+P) Marine Notices will be annually and  consecutively numbered.</p>
          <p className="text-primary-color font-17">Marine Notices will be valid for 5 years but may be withdrawn earlier if changes to information contained therein is  required or the information provided is no longer applicable.</p>

        </div>

        <div className="col-12">
          <h2 className="font-17 font-700 mb-1">Marine Notices (MN):</h2>
          <p className="mb-3 text-primary-color font-17">A  Marine Information Notice shall contain information which are temporary  in nature. Marine Information Notice’s (MIN’s) will also be issued to  advise industry of regulatory changes that will come into force in the  near future (e.g. change in telephone numbers, COVID 19 related,  suspension of level 3 examinations, office closures, forth coming  amendments to regulations, etc.).</p>
          <p className="text-primary-color font-17">Marine Information Notice’s will be  annually and consecutively numbered, e.g. MIN 01-21 A Marine Information Notice will be valid for a period of one year or may be withdrawn  earlier if changes to information are required or the information  provided is no longer applicable. If The information in the Marine  Information Notice is still valid at the end of the expiry date a new  MIN will be issued replacing the current Marine Information Notice.</p>
        </div>

        <div className="col-12">
          <h2 className="font-17 font-700 mb-1">Marine Alert (MA):</h2>
          <p className="mb-3 text-primary-color font-17">A Marine Alert shall contain information of lessons learned arising from investigations into incidents or casualties.</p>
          <p className="mb-3 text-primary-color font-17">A marine incident means an event, or sequence of events, other than a marine casualty, which has occurred directly in connection with the operations of a ship that endangered, or, if not corrected, would endanger the safety of the ship, its occupants or any other person or the environment or a marine casualty means which is an event, or a sequence of events, that has resulted in injury/loss of life/damage or loss of a ship or damage to the environment or a very serious marine casualty which involves the total loss of the ship or a death or severe damage to the environment</p>
          <p className="mb-3 text-primary-color font-17">Marine Alert’s will be numbered annually and numerically consecutive, e.g. MA 01-21.</p>
          <p className="text-primary-color font-17">A Marine Alert will have no expiry date but may be withdrawn earlier if, revisions to lessons learnt are required  due to amendments to legislation or emergence of new technology or similar occurrence in another incident which requires a review.</p>
        </div>

        <div className="col-12">
          <h2 className="font-17 font-700 mb-1">Marine Safety Flash (MSF):</h2>
          <p className="mb-3 text-primary-color font-17">A Marine Safety Flash shall be published when reliable information is received regarding failures to equipment, interferences from sources causing failure of other important equipment etc.</p>
          <p className="mb-3 text-primary-color font-17">Marine Safety Flash’s will be numbered annually and numerically consecutive, e.g. MSF 01-21.</p>
          <p className="mb-3 text-primary-color font-17">A Marine Safety Flash shall be valid until revoked or legislation is amended to address the contents of the MSF.</p>
          <p className="mb-3 text-primary-color font-17"><a href={Doc1} target="_blank" rel="noopener noreferrer" className="pdf-link" >
            <FaFilePdf style={{ marginRight: "5px" }} />List of validMarine Notices</a>
          </p>
          <p className="mb-3 text-primary-color font-17"><a href={Doc2} target="_blank" rel="noopener noreferrer" className="pdf-link" >
            <FaFilePdf style={{ marginRight: "5px" }} />List of valid Marine Information Notices</a>
          </p>
          <p className="mb-3 text-primary-color font-17"><a href={Doc3} target="_blank" rel="noopener noreferrer" className="pdf-link" >
            <FaFilePdf style={{ marginRight: "5px" }} />List of valid Marine Alerts</a>
          </p>

          <p className="mb-3 text-primary-color font-17"><a href={Doc4} target="_blank" rel="noopener noreferrer" className="pdf-link" >
            <FaFilePdf style={{ marginRight: "5px" }} />List of valid Marine Safety Flashes</a>
          </p>

        </div>


      </div>
    </>
  );
}

export default LegislationMarineRelatedInfomation;